/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.className : a tailwind class the would be implemented on span tag
 * @param props.strokeWidth : set the strokeWidth with px css
 */

interface PersonProps {
  color?: string
  className?: string
  strokeWidth?: string
}

const Invoice = (props: PersonProps) => {
  const { color = '#364152', strokeWidth = '1' } = props

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 18.3333H12.5C16.6667 18.3333 18.3333 16.6667 18.3333 12.5V7.5C18.3333 3.33333 16.6667 1.66667 12.5 1.66667H7.5C3.33333 1.66667 1.66666 3.33333 1.66666 7.5V12.5C1.66666 16.6667 3.33333 18.3333 7.5 18.3333Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 7.5H6.875"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 12.5H6.875"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Invoice
